import * as types from './mutation-types'


export const createProduct = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/product', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createProductVariations = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/product/variations', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const findProductById = ({ commit }, id) => {

    return new Promise((resolve, reject) => {
        window.axios.get(`product/${id}/details`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const importProducts = ({ commit }, data) => {
    let formData = new FormData();
    formData.append('file', data.file);
    formData.append('_method', 'POST');
    return new Promise((resolve, reject) => {
        window.axios.post(`import/products`, formData, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const exportProduct = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('export/products', { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'products.xlsx');
            document.body.appendChild(link);
            link.click();
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadProductModel = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('download-product-model', { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'model-product.xlsx');
            document.body.appendChild(link);
            link.click();
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const deleteProduct = ({ commit }, id) => {

    return new Promise((resolve, reject) => {
        window.axios.delete(`product/${id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProductSaleElement = ({ commit }, {productSaleElement, productId}) => {

    return new Promise((resolve, reject) => {
        window.axios.delete(`/productSaleElement/${productSaleElement}/product/${productId}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProductSaleElements = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/productSaleElements/update`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProductSaleElements = ({ commit }, {data, productId}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/productSaleElements/product/${productId}/delete`, {params: {productSaleElements: data}}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const loadAllProductSale = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/all/productSaleElements/collection').then((response) => {
            commit(types.LOAD_PRODUCT_SALE_ELEMENTS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const removeProductStore = ({commit}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.delete(`store/${data.id}/product/${data.product_sale_element_id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}



export const uploadImage = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('product/upload-avatar', data).then((response) => {
            commit(types.SET_IMAGE, { id: response.data.id, image: response.data.image })

            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const loadTypes = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/product/type/enum').then((response) => {
            commit(types.ADD_TYPES, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createProductSaleElementsLots = ({ commit }, data) => {

    console.log(data)
    return new Promise((resolve, reject) => {
        window.axios.post('store/productSaleElements/lots', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateProductSaleElementLot = ({ commit }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.patch('update/productSaleElement/lot/' + data.lot, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteProductLot = ({ commit }, id) => {

    return new Promise((resolve, reject) => {
        window.axios.delete(`productSaleElement/lot/${id}/delete`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getProductSalesPerProducts = ({commit, dispatch, state}, products) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/productSaleElements/by/products', {
            params: {
                products: products
            }
        }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadBarcodes = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('barcode/download', {
            params: params,
            responseType: 'blob'
        }).then((response) => {
            const contentDisposition = response.headers['content-disposition'] || ''
            const matchFilename = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            
            let defaultFilename = 'barcodes.pdf'
            if (params.product_id) defaultFilename = 'barcodes_produit.pdf'
            else if (params.shop_id) defaultFilename = 'barcodes_boutique.pdf'
            else if (params.society_id) defaultFilename = 'barcodes_societe.pdf'
            else if (params.product_sale_element_id) defaultFilename = 'barcodes_variation.pdf'
            else if (params.lot_id) defaultFilename = 'barcodes_lot.pdf'

            let filename = matchFilename ? matchFilename[1].replace(/['"]/g, '').trim() : defaultFilename

            // Ensure correct extension based on content-type
            const contentType = response.headers['content-type'] || 'application/pdf'
            if (contentType.includes('pdf') && !filename.endsWith('.pdf')) {
                filename = filename.replace(/\.\w+$/, '') + '.pdf'
            }

            const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const downloadBarcodesBundles = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('barcode/download/bundles', {
            params: params,
            responseType: 'blob'
        }).then((response) => {
            const contentDisposition = response.headers['content-disposition'] || ''
            const matchFilename = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            
            let defaultFilename = 'barcodes.pdf'
            if (params.bundle_id) defaultFilename = 'barcodes_pack.pdf'
            else if (params.shop_id) defaultFilename = 'barcodes_boutique.pdf'
            else if (params.society_id) defaultFilename = 'barcodes_societe.pdf'

            let filename = matchFilename ? matchFilename[1].replace(/['"]/g, '').trim() : defaultFilename

            // Ensure correct extension based on content-type
            const contentType = response.headers['content-type'] || 'application/pdf'
            if (contentType.includes('pdf') && !filename.endsWith('.pdf')) {
                filename = filename.replace(/\.\w+$/, '') + '.pdf'
            }

            const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const generateReference = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('barcode/reference/generate', { params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
